import { useState } from "react";

/**
 * <BrandLogo /> renders the restaurant's logo image with a text-based
 * fallback if the file cannot be loaded. This lets the site look correct
 * even before the logo file is uploaded to /public/images/site/.
 */
export default function BrandLogo({ src, size = "md", className = "" }) {
  const [failed, setFailed] = useState(false);

  const heights = { sm: "h-10", md: "h-14 md:h-16", lg: "h-20" };
  const scriptSize = {
    sm: "text-2xl",
    md: "text-3xl md:text-4xl",
    lg: "text-4xl md:text-5xl",
  };
  const tagSize = {
    sm: "text-[9px]",
    md: "text-[10px] md:text-[11px]",
    lg: "text-[11px] md:text-xs",
  };

  if (!failed) {
    return (
      <img
        src={src}
        alt="Shaan Curry House"
        onError={() => setFailed(true)}
        className={`${heights[size]} w-auto object-contain ${className}`}
      />
    );
  }

  return (
    <div className={`flex flex-col items-start leading-none select-none ${className}`}>
      <span
        className={`font-display italic font-bold text-[#ffd100] tracking-tight ${scriptSize[size]}`}
      >
        Shaan
      </span>
      <span className={`text-white/90 font-semibold tracking-[0.28em] mt-1 ${tagSize[size]}`}>
        CURRY&nbsp;HOUSE
      </span>
    </div>
  );
}
